import { Stack, Typography } from "@mui/material";
import type { FC } from "react";

import type { UUID } from "../../../../utils/uuid";
import { PollsExportButton } from "./export-button";

export const PollsOverviewHeader: FC<{
  question: string;
  sentTimes: number;
  poll_id: UUID;
}> = ({ question, sentTimes, poll_id }) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h6" fontWeight={600}>
        {question}
      </Typography>
      <Stack direction="row" spacing={2} alignItems="center">
        {sentTimes > 1 && <Typography variant="body2">Sent {sentTimes} times</Typography>}
        <PollsExportButton poll_id={poll_id} />
      </Stack>
    </Stack>
  );
};
